import { render, staticRenderFns } from "./NotifyUsersComponent.vue?vue&type=template&id=1ef80f0e&scoped=true"
import script from "./NotifyUsersComponent.vue?vue&type=script&lang=js"
export * from "./NotifyUsersComponent.vue?vue&type=script&lang=js"
import style0 from "./NotifyUsersComponent.vue?vue&type=style&index=0&id=1ef80f0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef80f0e",
  null
  
)

export default component.exports